export const MAIN_ITEM_LOCAL_STORAGE = 'cotizadorVentasBrandinData'
export const DEFAULT_ERROR_MESSAGE =
  'Ha ocurrido un error, por favor inténtelo de nuevo más tarde'
export const CART_LOCAL_STORAGE = 'cartData'
export const CART_COUNT_LOCAL_STORAGE = 'cartCountData'
